module.exports = __webpack_public_path__ + "img/01.a2ecf96c.png";